import { FormattedNumber } from 'react-intl';

import { Flag } from '@xing-com/flag';
import { Link } from '@xing-com/link';
import { Tag } from '@xing-com/tag';
import { BodyCopy } from '@xing-com/typography';

import type { SearchParams, SetSearchParams } from '../../hooks';
import { FilterContainer, TagsContainer } from '../shared-styles';

export type Aggregations = Array<{
  count?: number;
  label: {
    localizationValue: string;
  };
  value: number | string;
}>;

type FilterTagAreaProps = {
  aggKey: string;
  aggKeyText: string | null;
  filterData: Aggregations;
  searchParams: SearchParams;
  setSearchParams: SetSearchParams;
  isMultiSelect?: boolean;
  upsellLink?: string;
};

export const FilterTagArea: React.FC<FilterTagAreaProps> = ({
  aggKey,
  aggKeyText,
  filterData,
  searchParams,
  setSearchParams,
  isMultiSelect = true,
  upsellLink = '',
}) => {
  const queryKey = aggKey;

  const queryValue = (searchParams[queryKey] || '')
    .toString()
    .split(',')
    .filter(Boolean);

  const handleOnClick = (aggValue: string, isSelected: boolean): void => {
    const queryValues = isSelected
      ? queryValue.filter((value) => value !== aggValue)
      : [...queryValue, aggValue];

    const newParams = {
      [queryKey]: isMultiSelect ? queryValues.join(',') : aggValue,
    };

    setSearchParams(newParams);
  };

  return (
    <FilterContainer data-testid={aggKey}>
      <BodyCopy fontWeight="bold" noMargin as="h3">
        {aggKeyText}&ensp;
        {upsellLink.length ? (
          <Link to={upsellLink} data-testid="premium-upsell">
            <Flag size="small" variant="premium" />
          </Link>
        ) : null}
      </BodyCopy>
      <TagsContainer>
        {filterData.map((agg, i) => {
          const aggValue = agg.value.toString();
          const isSelected = queryValue.includes(aggValue);

          return (
            <Tag
              key={i}
              selected={isSelected}
              disabled={Boolean(upsellLink)}
              onClick={() => handleOnClick(aggValue, isSelected)}
            >
              {agg.count ? (
                <>
                  {agg.label?.localizationValue} (
                  <FormattedNumber value={agg.count} />)
                </>
              ) : (
                agg.label?.localizationValue
              )}
            </Tag>
          );
        })}
      </TagsContainer>
    </FilterContainer>
  );
};
